import { createSelector } from 'reselect';

export const selectList = createSelector(list => list.get('data'), list => (list ? list.toJS() : []));

export const selectShow = createSelector(show => show.get('data'), show => (show ? show.toJS() : null));

export const selectCurrentEpisode = createSelector(
  (episodes, episodeId) =>
    episodes.get('data') ? episodes.get('data').find(ep => ep.get('id') === parseInt(episodeId, 10)) : null,
  episode => (episode ? episode.toJS() : null)
);

export const selectCurrentShow = createSelector(
  (shows, showId) =>
    shows.get('data') ? shows.get('data').find(show => show.get('id') === parseInt(showId, 10)) : null,
  show => (show ? show.toJS() : null)
);



// WEBPACK FOOTER //
// ./src/subscription/tv/redux/selectors.js